<template>
    <!-- что важно родителям-->
    <div class="block-parents">
        <div class="block-parents__body">
            <div class="block-parents__content">
                <div class="block-parents__box block-parents__box-two">
                    <p class="block-parents__text block-parents__text-two">
                        <span class="block-parents__title">Что важно <br> родителям</span>
                        Родителям подростков можно лишь посоветовать: <s>бегите</s> запаситесь терпением, книгами по выживанию и берушами. Хорошо, если есть возможность выделить ребенку отдельную комнату или какое-то пространство в квартире, где он будет полноправным хозяином. Своя комната для подростка — крепость.<br><br>
                        Подростку нужно больше самостоятельности, доверия и поддержки. Он вполне может сам&nbsp;ходить на дополнительные занятия и&nbsp;гулять вечерами с друзьями <a href="https://www.pik.ru/deti/parks?utm_source=pikabu.ru&utm_campaign=general&utm_medium=referral&utm_content=timeline" class="app__link app__link--red" target="_blank">во дворе или в&nbsp;кафешках</a>. Организм требует адреналина и&nbsp;громкой музыки — сопротивляться бесполезно. Лучше подарите хорошие наушники или новый&nbsp;скейт.
                    </p>
                    <BlockParallax
                        fixed
                        speed="20"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-one"
                    >
                        <img
                            srcset="../assets/5-img.jpg, ../assets/5-img@2x.jpg 2x"
                            src="../assets/5-img.jpg"
                            class="block-parents__img"
                        >
                        <div class="image-caption"></div>
                    </BlockParallax>
                </div>
            </div>
            <BlockParallax class="block-parents__icon block-parents__zapato block-parents--icon-desktop" speed="15">
                <img src="@/assets/images/icons/kk-2.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__hp block-parents--icon-desktop" speed="5">
                <img src="@/assets/images/icons/hp-2.png">
            </BlockParallax>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-parents {
        margin-top 3rem
        position relative
        +layout-md-and-up() {
            margin-top 0
        }
        &__body {
            position relative
            +layout-md-and-up() {
                display flex
            }
        }
        &__box-one {
            margin-top 2.2rem
            +layout-md-and-up() {
                display: flex
            }
            +layout-md-and-up() {
                padding-left: 8rem
            }
        }
        &__box-two {
            +layout-md-and-up() {
                display: flex
                flex-direction row-reverse
                margin-left: -6rem
            }
        }
        &__title {
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            margin-top 0
            margin-bottom 2rem
            color $color-text
            font-weight $font-semiBold
            display block
            +layout-sm-and-up() {
                text-align: center
                padding: 0
            }
            +layout-md-and-up() {
                font-size 3rem
                margin-top 0.5rem
                line-height 3.5rem
                text-align left
            }

        }
        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
            +layout-md-and-up() {
                max-width 35rem
                padding: 0
            }
        }
        &__text-one {

        }
        &__text-two {
            +layout-md-and-up() {
                max-width 42rem
                padding-left: 8rem
            }
        }
        &__img-box-one {
            margin-left -1rem
            margin-right -1rem
            margin-top 2rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left auto
            }
            +layout-md-and-up() {
                margin-top 4rem
                margin-left 5rem
            }
        }
        &__img-box-two {
            padding-left 3rem
            margin-right -1rem
            margin-top 2.5rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left: auto
                margin-right: auto
                padding-left: 0
            }
            +layout-md-and-up() {
                margin-left 6rem
                margin-top 9rem
            }
        }
        &__img {
            width: 100%
            margin-left auto
            display block
            +layout-sm-and-up() {
                align-self flex-start
                margin-right: 0
            }
        }

        &__icon {
            position absolute
            pointer-events none
            user-select none
        }
        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__zapato {
            top 55rem
            width 8rem
            +layout-md-and-up() {
                width auto
                top 14rem
                left -7rem
            }
        }
        &__hp {
            +layout-md-and-up() {
                top 22rem
                right -9rem
                width 8rem
            }
        }
    }
    .mini-block {
        clear both
        display block
        width 100%
        max-width 640px
        margin 5rem auto
        display flex
        flex-direction row
        flex-wrap nowrap
        &__title {
            max-width 320px
            h4 {
                padding-bottom 31px
                font-size 24px
                font-weight 600
                letter-spacing 0.26px
                line-height 1.44
                color: #222222
            }
        }
        &__button {
            padding 13px 39px 14px
            font-size 16px
            font-weight 600
            letter-spacing 0.17px
            border-radius 5px
            background-color #66bd5a
            color #fff
            &:hover {
                background-color #51bf42
            }
        }
        &__image {
            img {
                width auto
                max-height 215px
            }
        }
        @media screen and (max-width: 700px) {
            max-width 410px
            flex-direction row-reverse
            &__image {
                overflow hidden
                width 8rem
                height 8rem
                border-radius 50%
                margin-right 2rem
                
                img {
                    width auto
                    height 100%
                }
            }
        }
        @media screen and (max-width: 470px) {
            padding 1rem
            &__image {
                display none
            }
        }
    }
</style>
